import request from "@/config/utils/request";

// 常见问题一级目录
export function queryFaqClassifyTree(data) {
  return request({
    url: "/apis/bid/hc/faqclassify/listFaqClassifyTree",
    method: "post",
    data
  });
}
// 查询常见问题列表接口服务
export function queryFaqProblemList(obj) {
  return request({
    url: "/apis/bid/hc/faqProblem/listFaqProblem",
    method: "post",
    data: obj
  });
}
// 查询常见问题详情接口服务
export function queryFaqProblemById(obj) {
  return request({
    url: "/apis/bid/hc/faqProblem/getFaqProblemById",
    method: "post",
    data: obj
  });
}
